import type { StayPlanContract } from "@/hooks/useStayPlanContracts";

/** O plano semanal de creche ativo, com dias fixos, que gera as diárias do pet. */
export function selectActiveWeeklyPlan(contracts: StayPlanContract[]): StayPlanContract | null {
  return contracts.find((contract) =>
    contract.status === "active" && contract.usageRule === "per_week" && contract.fixedWeekdays.length > 0,
  ) ?? null;
}
